import { getBaseUrl, request } from 'src/helper/api';

const getUsersFilterOptions = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/users/filters`,
      contentType: 'json',
      token,
      signal,
    },
    'filters/getUsersFilterOptions',
  );
export default getUsersFilterOptions;
